import { Request } from "./../services/Requests";

const RequestBuilder = new Request.Builder("inspiration", "marketplace");

const client = {
    getMerchantEvaluations(country: string, locale: string, shopId: string, resultsOffset: number): Promise<any> {
        const template = "/merchantevaluations/country/{country}/locale/{locale}/shopid/{shopId}";
        const pathParams = { country, locale, shopId };
        return RequestBuilder.path(template, pathParams)
            .query({ "results-offset": resultsOffset })
            .get();
    },
    getMerchantInformation(country: string, merchantId: string) {
        const template = "/merchantinformation/country/{country}/shopid/{merchantId}";
        const pathParams = { country, merchantId };
        return RequestBuilder.path(template, pathParams).get();
    }
};

export default client;
